export default "<app-common-product-rule-template [viewtoEditLastChild] = \"viewtoEditLastChild\" [reqData]=\"reqData\"></app-common-product-rule-template>\n";